import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {FpaEntity} from '../../fpa/fpa-entity';
import {FpaScenario} from '../../fpa/fpa-scenario';
import {SelectionItem} from '../../selections/selection-item';
import {FpaService} from '../../services/fpa-service';
import {SelectionService} from '../../services/selection-service';
import {StringUtils} from '../../utils/string-utils';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogActions } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { CurrencyPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'fpa-scenario-dialog',
    templateUrl: './fpa-scenario-dialog.component.html',
    styleUrls: ['./fpa-scenario-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatDialogActions, MatButton, CurrencyPipe]
})
export class FpaScenarioDialogComponent implements OnInit {
  private readonly fpaService = inject(FpaService);
  private readonly selectionService = inject(SelectionService);
  dialogRef = inject<MatDialogRef<FpaScenarioDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);


  public fpaScenario: FpaScenario;
  public fpaEntity: FpaEntity;
  readonly isBusy = signal<boolean>(undefined!);
  readonly errorMessage = signal<string>(undefined!);
  readonly channels = signal<SelectionItem[]>(undefined!);
  public warningMessages!: string[];

  constructor
  () {
    const data = this.data;

    this.fpaScenario = JSON.parse(JSON.stringify(data.scenario)) as FpaScenario;
    this.fpaEntity = data.fpaEntity as FpaEntity;
  }

  ngOnInit(): void {
    this.selectionService.getOrganizationChannels(this.fpaEntity.sellingOrgId).subscribe(results => this.channels.set(results));
    this.warningMessages = this.getWarningMessages();
  }

  public invalidEntry(): boolean {
    if (this.allowMultiplierOnly()) {
      return !this.fpaScenario || !this.fpaScenario.requestedMultiplier || isNaN(+this.fpaScenario.requestedMultiplier);
    } else if (this.allowPoAmountOnly()) {
      return !this.fpaScenario || !this.fpaScenario.poAmount || isNaN(+this.fpaScenario.poAmount);
    }
    return true;
  }

  public getWarningMessages(): string[] {
    let messages: string[] = null!;
    let inProcess: string[] = ['RSM Approved', 'RSM Declined', 'Submitted'];
    if (inProcess.indexOf(this.fpaScenario.approvalStatus) > -1) {
      messages = ['This scenario is currently in the approval process.'];
      messages.push('Updates will halt and reset this process.');
    }
    return messages;
  }

  allowMultiplierOnly(): boolean {
    return this.fpaScenario && (this.fpaScenario.saleType == 'B' || this.fpaScenario.saleType == 'O');
  }

  allowPoAmountOnly(): boolean {
    return this.fpaScenario && this.fpaScenario.saleType == 'C';
  }

  clearInputs(): void {
    if (this.fpaScenario) {
      this.fpaScenario.poAmount = null!;
      this.fpaScenario.requestedMultiplier = null!;
    }
  }

  public saveAndClose(): void {
    this.isBusy.set(true);
    this.fpaService.saveScenario(this.fpaScenario).subscribe(result => {
      this.dialogRef.close(result);
    }, error => this.handleError(error));
  }

  private handleError(error: HttpErrorResponse): void {
    this.errorMessage.set(StringUtils.getErrorMessage(error));
    this.isBusy.set(false);
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }

}
